<template>
	<section class="section-base form-section-base">

		<div class="form-base">
			<div class="form-section-base__block-outer">
				<div class="form-section-base__block-inner">
					<v-row>
						<v-col>
							<div class="form-base__title">{{ Text.refusalDetailsTitle }}</div>
						</v-col>
					</v-row>

					<v-row>
						<v-col cols="12">
							<LoadAccountBankDetails @change="addFromAccountData"/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="4">
							<v-text-field
								v-model="$v.form.section1.accountNumber.$model"
								:errorMessages="
                getValidationErrorText($v.form.section1.accountNumber)
              "
								v-mask="Mask.ACCOUNT_NUMBER"
								outlined
								@blur="$v.form.section1.accountNumber.$touch"
							>
								<template v-slot:label>Номер счета<sup>*</sup></template>
							</v-text-field>
						</v-col>
						<v-col cols="4">
							<v-text-field
								v-model="$v.form.section1.corrAccountNumber.$model"
								:errorMessages="
                getValidationErrorText($v.form.section1.corrAccountNumber)
              "
								v-mask="Mask.ACCOUNT_NUMBER"
								outlined
								label="Номер корреспондентского счета"
								@blur="$v.form.section1.corrAccountNumber.$touch"
							/>
						</v-col>
						<v-col cols="4">
							<DadataBankField
								v-model="$v.form.section1.bic.$model"
								:mask="Mask.BIC"
								:errorMessages="getValidationErrorText($v.form.section1.bic)"
								outlined
								label="БИК"
								:suggestions="suggestions"
								field="bic"
								@suggest="onSelect"
								@blur="$v.form.section1.bic.$touch"
							/>
						</v-col>
						<template v-if="roleType !== Role.PERSON">
							<v-col cols="6">
								<v-text-field
									label="ИНН"
									v-model="$v.form.section1.inn.$model"
									v-mask="Mask.INN_ORG"
									:errorMessages="getValidationErrorText($v.form.section1.inn)"
									outlined
									@blur="$v.form.section1.inn.$touch"
								/>
							</v-col>
							<v-col cols="6">
								<v-text-field
									label="КПП"
									v-model="$v.form.section1.kpp.$model"
									v-mask="KPP"
									:errorMessages="getValidationErrorText($v.form.section1.kpp)"
									outlined
									@blur="$v.form.section1.kpp.$touch"
								/>
							</v-col>
						</template>

						<v-col cols="12">
							<DadataBankField
								v-model="$v.form.section1.bankName.$model"
								:errorMessages="getValidationErrorText($v.form.section1.bankName)"
								outlined
								label="Наименование банка получателя"
								:suggestions="suggestions"
								field="bankName"
								@suggest="onSelect"
								@blur="$v.form.section1.bankName.$touch"
							/>
						</v-col>
						<v-col cols="12" class="py-0 text-small-size">
							<p>{{ $t('noticeRecovery.account.accountNumberHelper')}}</p>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="form-section-base__block-outer">
				<div class="form-section-base__block-inner">
					<v-row>
						<v-col cols="12">
							<v-checkbox
								v-model="$v.form.section2.hasPrivilege.$model"
								label="Наличие льготы"
								hide-details
							/>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="$v.form.section2.note.$model"
								:errorMessages="getValidationErrorText($v.form.section2.note)"
								outlined
								label="Примечание (основание для льготы, при наличии)"
								@blur="$v.form.section2.note.$touch"
							/>
							<span class="text-small-size">{{  $t('noticeRecovery.account.hasPrivilegeNote')}}</span>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="form-section-base__block-outer">
				<div class="form-section-base__block-inner">
					<v-row>
						<v-col cols="12">
							<v-checkbox
								v-model="$v.form.section2.edocToFoiv.$model"
								label="Прошу после совершения нотариального действия передать электронный документ, на котором совершена исполнительная надпись в электронной форме, в федеральный орган исполнительной власти, осуществляющий функции по обеспечению установленного порядка деятельности судов, исполнению судебных актов, актов других органов и должностных лиц, правоприменительные функции и функции по контролю и надзору в установленной сфере деятельности, посредством единой информационной системы нотариата с использованием единой системы межведомственного электронного взаимодействия"
								:error-messages="
                getValidationErrorText($v.form.section2.edocToFoiv)
              "
								hide-details
							/>
						</v-col>
						<v-col cols="4">
							Структурное подразделение территориального органа ФССП России
						</v-col>
						<v-col cols="3">
							<v-autocomplete
								v-model="$v.regionCodeFssp.$model"
								:errorMessages="getValidationErrorText($v.form.regionCodeFssp)"
								outlined
								label="Субъект Российской Федерации"
								item-text="regionName"
								item-value="regionCode"
								return-object
								@change="changeRegionCodeFssp"
								:items="regions"
								:filter="
                (item, queryText) => {
                  return (
                    item.regionName
                      .toLocaleLowerCase()
                      .indexOf(queryText.toLocaleLowerCase()) > -1
                  );
                }
              "
								@blur="$v.regionCodeFssp.$touch"
							>
								<template v-slot:item="data">
									<v-list-item-content>
										<v-list-item-title
										>{{ data.item.regionName }}
										</v-list-item-title>
										<v-list-item-subtitle
										>код региона:
											{{ data.item.regionCode }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="5">
							<v-autocomplete
								v-model="$v.form.section2.fsspSubdivision.$model"
								:items="fsspEntries"
								item-text="name"
								item-value="code"
								:loading="isLoadingFssp"
								outlined
								hide-no-data
								return-object
								clearable
								:errorMessages="
                getValidationErrorText($v.form.section2.fsspSubdivision)
              "
								:filter="filterFssp"
								@blur="$v.form.section2.fsspSubdivision.$touch"
							>
								<template v-slot:item="data">
									<v-list-item-content>
										<v-list-item-title class="autocomplete-title">
											{{ data.item.name }}
										</v-list-item-title>
										<v-list-item-subtitle>
											код: {{ data.item.code }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-checkbox
								v-model="$v.form.section2.hasAnnouncement.$model"
								label="Заявитель подтверждает, что на момент подачи настоящего заявления между ним и должником не имеется споров, в том числе в суде"
								:error-messages="
                getValidationErrorText($v.form.section2.hasAnnouncement)
              "
							/>
						</v-col>
					</v-row>
				</div>
			</div>
		</div>
		<v-container>
			<Footer
				@next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
				@prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
				:loading-next="loadingNext"
			/>
		</v-container>
	</section>
</template>

<script>
import {helpers, maxLength, minLength, required, requiredIf} from 'vuelidate/lib/validators';
import cloneDeep from 'clone-deep';

import {
	ACCOUNT_NUMBER_NO_REPEATING, ACCOUNT_NUMBER_CHECKSUM,
	EMOJI,
	getValidationErrorText, HAS_ANNOUNCEMENT_RULE,
	INN,
	KPP, MinLength, ORG_ACCOUNT_NUMBER,
	REQUIRED_BOOLEAN, TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import {ServicesModule} from '@/store/modules/services';
import {getFsspSubdivision} from '@/api/services';
import Footer from '@/components/services/elements/Footer';
import {RegionModule} from '@/store/modules/region';
import {checkInvalid, leaveStep, Text} from '@/utils/services';
import {StepDirection, StepName} from '@/types/services';
import {bankDetails} from '@/components/services/elements/BankDetails';
import {configRegionsCode} from '@/app.config';
import deepmerge from 'deepmerge';
import LoadAccountBankDetails from '@/components/services/elements/LoadAccountBankDetails';
import {Mask, NoticeRecoveryStep} from '@/constants';
import {Role} from '@/utils/dictionaries';
import DadataBankField from '@/components/base/DadataBankField';
import {ErrorAlertModule} from "@/store/modules/errors";


export default {
	name: 'AccountBankDetails',
	components: {
		Footer,
		LoadAccountBankDetails,
		DadataBankField,
	},
	props: {
		loadingNext: {
			type: Boolean,
			required: true,
		},
		roleType: {
			type: String,
			required: true,
		},
	},
	validations() {
		return {
			form: {
				section1: {
					accountNumber: {
						required,
						minLength: minLength(20),
						ACCOUNT_NUMBER_NO_REPEATING: (value) => {
							return ACCOUNT_NUMBER_NO_REPEATING(value)()
						},
						ACCOUNT_NUMBER_CHECKSUM: (value, {bic}) => {
							return ACCOUNT_NUMBER_CHECKSUM(value, bic)();
						},
						ORG_ACCOUNT_NUMBER: (value) => {
							if (this.$props.roleType !== Role.PERSON) {
								return ORG_ACCOUNT_NUMBER(value)()
							}
							return true
						},
						IS_NOT_EQUAL: helpers.withParams(
							{type: 'IS_NOT_EQUAL'},
							(value) => {
                if (!value) return true
                return value !== this.$v.form.section1.corrAccountNumber.$model
							}
						)
					},
					corrAccountNumber: {
						required,
						minLength: minLength(20),
						ACCOUNT_NUMBER_NO_REPEATING: (value) => {
							return ACCOUNT_NUMBER_NO_REPEATING(value)()
						},
						ACCOUNT_NUMBER_CHECKSUM: (value, {bic}) => {
							return ACCOUNT_NUMBER_CHECKSUM(value, bic, true)();
						},
						IS_NOT_EQUAL: helpers.withParams(
							{type: 'IS_NOT_EQUAL'},
							(value) => {
                if (!value) return true
								return value !== this.$v.form.section1.accountNumber.$model
							}
						)
					},
					bic: {
						required,
						minLength: minLength(MinLength.BIC),
					},
					bankName: {
						required,
						maxLength: maxLength(255),
						EMOJI,
						TRAILING_AND_LEADING_SPACES
					},
					inn: {
						minLength: minLength(10),
						INN: INN(10),
					},
					kpp: {
						minLength: minLength(9),
						KPP,
					},
				},
				section2: {
					hasPrivilege: {},
					hasAnnouncement: {
						required: REQUIRED_BOOLEAN,
						HAS_ANNOUNCEMENT_RULE: function (value) {
							return HAS_ANNOUNCEMENT_RULE(value)
						},
					},
					note: {
						required: requiredIf('hasPrivilege'),
						maxLength: maxLength(4000),
						EMOJI,
						TRAILING_AND_LEADING_SPACES
					},
					fsspSubdivision: {
						required: requiredIf('edocToFoiv'),
						maxLength: maxLength(1000),
						TRAILING_AND_LEADING_SPACES
					},
					edocToFoiv: {
						required: REQUIRED_BOOLEAN,
					},
				},
			},
			regionCodeFssp: {
				required: requiredIf('edocToFoiv'),
			},
		};
	},
	data: () => ({
		StepDirection,
		StepName,
		leaveStep,
		getValidationErrorText,
		Text,
		Mask,
		Role,
		fsspEntries: [],
		isLoadingFssp: false,
		regionCodeFssp: {},
		invalidFields: [],
		suggestions: [],

		//form data
		form: {
			section1: deepmerge(bankDetails, {
				inn: '',
				kpp: '',
			}),
			section2: {
				hasPrivilege: false,
				note: '',
				fsspSubdivision: null,
				edocToFoiv: true,
				hasAnnouncement: false
			},
		},
	}),
	computed: {
		regions() {
			if (!configRegionsCode || configRegionsCode.toLowerCase() === 'all') {
				return RegionModule.list;
			}
			return RegionModule.list.filter((region) =>
				configRegionsCode.split(';').includes(region.regionCode)
			);
		},
	},
	created() {
		this.prefillDraft();
	},
	async mounted() {
		if (!RegionModule.loading && !RegionModule.loaded) {
			await RegionModule.loadRegionsAll();
		}
	},
	methods: {
		touchFields() {
			this.invalidFields = [];
			this.$v.$touch();
			checkInvalid(this.$v, this.invalidFields);
		},

		filterFssp(item, queryText) {
			const textOne = item.name.toLowerCase();
			const textTwo = item.code.toLowerCase();
			const searchText = queryText.toLowerCase();

			return textOne.includes(searchText) || textTwo.includes(searchText);
		},

		assemblyModel() {
			let ABDStore = {};
			let ENRDStore = {};

			if (ServicesModule.statement.accountBankDetails) {
				ABDStore = {...ServicesModule.statement.accountBankDetails};
			}
			if (ServicesModule.statement.executiveNoticesRecoveryDetails) {
				ENRDStore = {
					...ServicesModule.statement.executiveNoticesRecoveryDetails,
				};
			}

			return {
				accountBankDetails: {
					...cloneDeep(ABDStore),
					...cloneDeep(this.form.section1),
				},
				executiveNoticesRecoveryDetails: {
					...cloneDeep(ENRDStore),
					...cloneDeep(this.form.section2),
				},
			};
		},

		prefillDraft() {
			let AModelStore = {};
			let EModelStore = {};

			if (ServicesModule.statement.accountBankDetails) {
				AModelStore = cloneDeep(ServicesModule.statement.accountBankDetails);
			}
			if (ServicesModule.statement.executiveNoticesRecoveryDetails) {
				EModelStore = cloneDeep(
					ServicesModule.statement.executiveNoticesRecoveryDetails
				);
			}

			// предзаполняем фссп
			if (EModelStore && EModelStore.fsspSubdivision) {
				this.fsspEntries = [{...EModelStore.fsspSubdivision}];
			}
			// предзаполняем регион для фссп
			this.prefillRegionFssp();

			this.form = {
				section1: {
					...cloneDeep(this.form.section1),
					...cloneDeep(AModelStore),
				},
				section2: {
					...cloneDeep(this.form.section2),
					...cloneDeep(EModelStore),
					fsspSubdivision: this.regionCodeFssp.regionCode
						? EModelStore.fsspSubdivision
						: null,
				},
			};
		},

		/*
		 *  Предзаполняем регион для фильтрации фссп fssp
		 *  Получаем массив фсс по региону + предзаполненный элемент, если есть
		 */
		prefillRegionFssp() {
			const debtorStore = cloneDeep(ServicesModule.statement.subjects.debtor);
			let regionName = null;
			if (debtorStore && debtorStore.person) {
				regionName = debtorStore.person.address.regionName;
			}
			if (debtorStore && debtorStore.organization) {
				regionName = debtorStore.organization.factAddress.regionName;
			}
			if (debtorStore && debtorStore.foreignOrganization) {
				regionName = debtorStore.foreignOrganization.address.regionName;
			}

			const debtorAvailableRegion = this.regions.filter((item) =>
				item.regionName.includes(regionName)
			)[0];

			if (debtorAvailableRegion) {
				this.regionCodeFssp = debtorAvailableRegion;
				this.loadFsspEntries(
					null,
					this.regionCodeFssp.regionCode,
					this.fsspEntries
				);
			}
		},

		changeRegionCodeFssp() {
			this.form.section2.fsspSubdivision = null;
			this.loadFsspEntries(null, this.regionCodeFssp.regionCode);
		},

		/*
		 *  Получаем справочник fssp
		 */
		loadFsspEntries(value, regionCode, fsspDraft) {
			this.fsspEntries = [];
			this.isLoadingFssp = true;
			getFsspSubdivision({
				regionCode: regionCode,
				name: value,
			})
				.then((res) => {
					this.fsspEntries = [...(fsspDraft || []), ...res];
				})
				.catch(() => {
					this.fsspEntries = [];
				})
				.finally(() => (this.isLoadingFssp = false));
		},

		addFromAccountData(data) {
			if (data) {
				this.$v.form.section1.accountNumber.$model = data.accountNumber;
				this.$v.form.section1.corrAccountNumber.$model = data.corrAccountNumber;
				this.$v.form.section1.bankName.$model = data.bankName;
				this.$v.form.section1.bic.$model = data.bic;
			}
		},

		btnSaveClickHandler(direction) {
			if (!this.$v.form.section2.hasAnnouncement.$model) {
				ErrorAlertModule.setErrorAlert('Необходимо указать в заявлении отсутствие спора в суде');
			} else {
				ErrorAlertModule.setErrorAlert('');
			}
			leaveStep({
				stepThis: this,
				direction,
				step: NoticeRecoveryStep.ACCOUNT_BANK_DETAILS,
			});
		},

		onSelect: function (data) {
			this.suggestions = [data];
			this.$v.form.section1.corrAccountNumber.$model = data.corrAccountNumber;
			this.$v.form.section1.bankName.$model = data.bankName;
			this.$v.form.section1.bic.$model = data.bic;
		}
	},
};
</script>

<style scoped lang="scss">
.autocomplete-title {
	white-space: normal;
}
</style>
